import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo
} from 'react';
import * as SDGAPI from '../Api/SDG';
import React from 'react';
export const SDGContext = createContext();
export const useSDG = () => useContext(SDGContext);

export const SDGProvider = ({
  children
}) => {
  const [initialLoad, setInitialLoad] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [SDG, setSDG] = useState([]);
  const [SDGID, setSDGIG] = useState({});
  const [SDGCategoryID, setSDGCategoryID] = useState({});


  const refreshSDG = useCallback(async() => {
    if(localStorage.getItem("auth_token") !== null){
      try {
          setError();
          setLoading(true);
          const data = await SDGAPI.getAllSDG();
          setSDG(data);
          return data;
      } catch (error) {
          setError(error);
      } finally {
          setLoading(false)
      }
    }
  }, []);




  useEffect(() => {
      if (!initialLoad) {
        refreshSDG();
        setInitialLoad(true);
      }
  }, [initialLoad, refreshSDG]);


  const getSDGbyID = useCallback(async(id) => {
    try {
        setError();
        setLoading(true);
        const data = await SDGAPI.getSDGbyID(id);
        setSDGIG(data);
        return data;
    } catch (error) {
        setError(error);
    } finally { 
        setLoading(false)
    }

  }, []);


  const getSDGbyCategoryID = useCallback(async(id) => {
    try {
        setError();
        setLoading(true);
        const data = await SDGAPI.getSDGbyCategoryID(id);
        setSDGCategoryID(data);
        return data;
    } catch (error) {
        setError(error);
    } finally { 
        setLoading(false)
    }

  }, []);


 

  const value = useMemo(() => ({
      refreshSDG,
      SDG,
      error,
      loading,
      SDGID,
      SDGCategoryID,
      getSDGbyID,
      getSDGbyCategoryID      
  }), [refreshSDG,SDG, error, loading,SDGID,SDGCategoryID, getSDGbyID,getSDGbyCategoryID]);

  return ( <SDGContext.Provider value = {value} > {
          children
      } </SDGContext.Provider>
  );
};